// extracted by mini-css-extract-plugin
export default {"root":"root__oiqhE","dmRoot":"dmRoot__HkfhZ","searchIcon":"searchIcon__p8sea","label":"label__j5ONu"};